export enum OrderModalPaymentType {
  VALUE = 'VALUE',
  PERCENTAGE = 'PERCENTAGE',
}
